import React from "react";
import "./index.less";

class listOfThirdSDK extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        // document.title = '第三方SDK清单慧管车';
        return (
            <div className="page_type_h5_select">
                <article id="listOfThirdSDK">
                    <h2 style={{ textAlign: "center" }}>第三方SDK清单 </h2>
                    <p>
                        为保障远程慧联APP/小程序相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方及关联方提供的软件开发包（SDK）实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。我们对接入的相关SDK在目录中列明。
                    </p>
                    <p>
                        请注意，第三方SDK及关联方可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。
                    </p>
                    <h3>1、高德地图SDK</h3>
                    <p>运营方：高德软件有限公司</p>
                    <p>使用场景： 充电站推荐、违章热点等场景使用</p>
                    <p>处理目的：为了实现地图展示、定位、搜索等服务</p>
                    <p>
                        收集个人信息：经纬度、设备信息【如IP
                        地址、GNSS信息、网络类型、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息传感器信息（矢量、加速度、压力、方向、地磁）、设备信号强度信息】、设备标识信息（IDFA、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（设备品牌及型号、操作系统、运营商信息、屏幕分辨率）
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://lbs.amap.com/pages/privacy/"
                            style={{ color: "blue" }}
                        >
                            https://lbs.amap.com/pages/privacy/
                        </a>
                    </p>

                    <h3>2、高德定位SDK</h3>
                    <p>运营方：高德软件有限公司</p>
                    <p>使用场景： 充电站推荐、违章热点定位当前位置等场景使用</p>
                    <p>处理目的：为了向用户提供定位服务</p>
                    <p>
                        收集个人信息：经纬度、设备信息【如IP
                        地址、GNSS信息、网络类型、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息传感器信息（矢量、加速度、压力）、设备信号强度信息】、设备标识信息（IDFA、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（设备品牌及型号、操作系统、运营商信息、屏幕分辨率）
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://lbs.amap.com/pages/privacy/"
                            style={{ color: "blue" }}
                        >
                            https://lbs.amap.com/pages/privacy/
                        </a>
                    </p>
                    <h3>3、友盟SDK</h3>
                    <p>运营方：友盟同欣（北京）科技有限公司</p>
                    <p>使用场景： 统计用户点击行为等场景使用</p>
                    <p>使用目的：进行APP数据统计分析</p>
                    <p>
                        收集个人信息类型：设备信息（Android
                        ID/IDFA/OAID/OpenUDID/GUID ;
                        网络信息、位置信息、应用列表
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://www.umeng.com/page/policy"
                            style={{ color: "blue" }}
                        >
                            https://www.umeng.com/page/policy
                        </a>
                    </p>
                    <h4>4、小米push SDK</h4>
                    <p>运营方：北京小米移动软件有限公司</p>
                    <p>使用场景： APP内容推送服务信息等场景使用</p>
                    <p>处理目的：用于向您推送消息</p>
                    <p>
                        收集个人信息类型：设备标识(OAID、加密的Android
                        ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://dev.mi.com/distribute/doc/details?pId=1534"
                            style={{ color: "blue" }}
                        >
                            https://dev.mi.com/distribute/doc/details?pId=1534
                        </a>
                    </p>

                    <h3>5、Bugly SDK</h3>
                    <p>运营方：深圳市腾讯计算机系统有限公司</p>
                    <p>使用场景： 使用于统计应用崩溃统计场景</p>
                    <p>处理目的：统计用户奔溃</p>
                    <p>收集个人信息类型：设备信息、日志信息</p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56"
                            style={{ color: "blue" }}
                        >
                            https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56
                        </a>
                    </p>

                    <h3>6、e签宝 SDK</h3>
                    <p>运营方：杭州天谷信息科技有限公司</p>
                    <p>使用场景： 使用于应用内电子合同签署功能场景</p>
                    <p>处理目的：电子合同签订</p>
                    <p>
                        收集个人信息类型：姓名、手机号码、身份证号、电子合同相关文件
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://www.esign.cn/gw/fwxy/?current=2"
                            style={{ color: "blue" }}
                        >
                            https://www.esign.cn/gw/fwxy/?current=2
                        </a>
                    </p>

                    <h3>7、支付宝 SDK</h3>
                    <p>运营方：支付宝（中国）网络技术有限公司</p>
                    <p>使用场景： 使用于平台支付租金、充电费等场景</p>
                    <p>处理目的：进行支付宝支付</p>
                    <p>
                        收集个人信息类型：Android
                        ID、OAID、SSID、BSSID；系统设置、系统属性、设备型号、设备品牌、操作系统；IP
                        地址、网络类型、运营商信息、Wi-Fi 状态、Wi-Fi
                        参数、Wi-Fi 列表
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://opendocs.alipay.com/open/01g6qm"
                            style={{ color: "blue" }}
                        >
                            https://opendocs.alipay.com/open/01g6qm
                        </a>
                    </p>

                    <h3>8、微信Open SDK</h3>
                    <p>运营方：深圳市腾讯计算机系统有限公司</p>
                    <p>使用场景： 使用于平台支付租金、充电费等场景</p>
                    <p>处理目的：用户分享微信、微信支付</p>
                    <p>
                        收集个人信息类型：用户分享图片或内容、设备安装微信APP状态、设备型号信息
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
                            style={{ color: "blue" }}
                        >
                            https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8
                        </a>
                    </p>

                    <h3>9、网易智企易盾 SDK</h3>
                    <p>运营方：杭州网易智企科技有限公司</p>
                    <p>
                        使用场景：应用内容合规检测、业务风控反作弊、用户身份核验、应用安全加固等场景
                    </p>
                    <p>
                        处理目的：识别违规内容、防控黑灰产风险、核验用户身份、保障应用运行安全
                    </p>
                    <p>
                        收集个人信息类型：收集个人信息类型：用户送检的文本/图片/音视频内容、设备基础信息与唯一标识、网络状态与操作日志、账号及身份核验信息、应用运行基础信息
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://dun.163.com/clause/privacy"
                            style={{ color: "blue" }}
                        >
                            https://dun.163.com/clause/privacy
                        </a>
                    </p>

                    <h3>10、金融级实人认证SDK</h3>
                    <p>运营方：杭州阿里云智能科技有限公司</p>
                    <p>使用场景：车辆绑定场景</p>
                    <p>处理目的：活体检测+人脸比对，完成本人身份校验</p>
                    <p>
                        收集个人信息类型：人脸图像信息、设备基本信息（设备标识符、设备型号、操作系统版本）
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107281509_18386.html"
                            style={{ color: "blue" }}
                        >
                            https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202107281509_18386.html
                        </a>
                    </p>

                    {/* <h3></h3>
                    <p>

                    </p>
                    <p>
                        
                    </p>
                    <p>

                    </p>
                    <p>
                       
                    </p>
                    <p>
                        隐私政策链接：
                        <a
                            href="https://www.csjplatform.com/privacy"
                            style={{ color: "blue" }}
                        >
                            https://www.csjplatform.com/privacy
                        </a>
                    </p> */}
                </article>
            </div>
        );
    }
}

export default listOfThirdSDK;



// WEBPACK FOOTER //
// ./src/staticPage/listOfThirdSDK/index.js